(() => {
  const ITEM_SELECTOR = '[data-faq-preview-item]';
  const SUMMARY_SELECTOR = '[data-faq-preview-summary]';
  const ANSWER_SELECTOR = '[data-faq-preview-answer]';

  const prefersReducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setInitialHeight = (item) => {
    const answer = item.querySelector(ANSWER_SELECTOR);
    if (!answer) return;

    answer.style.height = item.open ? `${answer.scrollHeight}px` : '0px';
    answer.style.opacity = item.open ? '1' : '0';
  };

  const openItem = (item) => {
    const answer = item.querySelector(ANSWER_SELECTOR);
    if (!answer) {
      item.open = true;
      return;
    }

    item.classList.remove('is-faq-preview-closing');
    item.open = true;

    if (prefersReducedMotion()) {
      answer.style.height = 'auto';
      answer.style.opacity = '1';
      return;
    }

    answer.style.height = '0px';
    answer.style.opacity = '0';

    window.requestAnimationFrame(() => {
      answer.style.height = `${answer.scrollHeight}px`;
      answer.style.opacity = '1';
    });

    const onTransitionEnd = (event) => {
      if (event.target !== answer || event.propertyName !== 'height' || !item.open) return;
      answer.removeEventListener('transitionend', onTransitionEnd);
      answer.style.height = 'auto';
    };

    answer.addEventListener('transitionend', onTransitionEnd);
  };

  const closeItem = (item) => {
    const answer = item.querySelector(ANSWER_SELECTOR);
    if (!answer) {
      item.open = false;
      return;
    }

    item.classList.add('is-faq-preview-closing');

    if (prefersReducedMotion()) {
      item.open = false;
      item.classList.remove('is-faq-preview-closing');
      answer.style.height = '0px';
      answer.style.opacity = '0';
      return;
    }

    answer.style.height = `${answer.scrollHeight}px`;
    answer.style.opacity = '1';

    window.requestAnimationFrame(() => {
      answer.style.height = '0px';
      answer.style.opacity = '0';
    });

    const onTransitionEnd = (event) => {
      if (event.target !== answer || event.propertyName !== 'height') return;
      answer.removeEventListener('transitionend', onTransitionEnd);
      item.open = false;
      item.classList.remove('is-faq-preview-closing');
    };

    answer.addEventListener('transitionend', onTransitionEnd);
  };

  const init = (root = document) => {
    const items = Array.from(root.querySelectorAll(ITEM_SELECTOR));

    if (root.matches && root.matches(ITEM_SELECTOR)) {
      items.unshift(root);
    }

    items.forEach((item) => {
      if (item.dataset.faqPreviewReady === 'true') return;

      const summary = item.querySelector(SUMMARY_SELECTOR);
      if (!summary) return;

      item.dataset.faqPreviewReady = 'true';
      setInitialHeight(item);

      summary.addEventListener('click', (event) => {
        event.preventDefault();

        if (item.open) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
